import axiosInstance from '../main/axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import { initialize } from 'redux-form';

const INITIAL_VALUES = {
  grupoFisicoId: 0,
  contId: 0,
  pf_anel: 1,
};

export function sendForced(values) {
  const request = axiosInstance.post(`/planoforcado/sendforced?somenteSalvar=true`, values);

  return {
    type: '',
    payload: request,
  };
}

export function sendForcedSemSalvar(values) {
  const request = axiosInstance.post(`/planoforcado/sendforced?salvar=false`, values);

  return {
    type: '',
    payload: request,
  };
}

export function sendForcedComSalvar(values) {
  // Envia ao controlador E salva no banco (comportamento padrão)
  const request = axiosInstance.post(`/planoforcado/sendforced`, values);

  return {
    type: '',
    payload: request,
  };
}

export function sendCancelForced(values) {
  // Processar anéis selecionados usando bitmap (como na troca de plano)
  let anelBitmap = 0;
  for (let index = 1; index <= 4; index++) {
    let name = 'anel' + index;
    if (values[name]) {
      anelBitmap += Math.pow(2, index - 1); // 2^0=1, 2^1=2, 2^2=4, 2^3=8
    }
  }

  // Se nenhum anel selecionado ou todos selecionados (15 = 1+2+4+8), usa 0 (todos)
  const anel = anelBitmap === 0 || anelBitmap === 15 ? 0 : anelBitmap;

  const request = axiosInstance.delete(`/planoforcado/sendforced/${values.grupoFisicoId}/${values.contId}/${anel}`);

  return {
    type: '',
    payload: request,
  };
}

export function getPlanosAgendados(contId) {
  const request = axiosInstance.get(`/planoforcado/agendados/${contId}`);

  return {
    type: 'PLANOS_FORCADOS_AGENDADOS_FETCHED',
    payload: request,
  };
}

export function init() {
  return [showTabs('tabExec'), selectTab('tabExec'), initialize('planoForcadoForm', INITIAL_VALUES)];
}

//initialize('planoForm', INITIAL_VALUES)
